import React from 'react'

function CloudIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="381.479" height="88.03" viewBox="0 0 381.479 88.03" {...props}>
      <g
        fill="none"
        stroke="#627680"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        data-name="Group 56622"
        transform="translate(-103.5 -668.229)"
      >
        <path
          d="M484.479 755.76c0-21.731-19.987-15.071-19.987-15.071s3.119-15.485-18.2-15.485c1.223-21.837-33.793-34.137-52.809-18.235"
          data-name="Path 1347"
        ></path>
        <path
          d="M341.603 755.759c0-13.42 12.343-9.307 12.343-9.307s-1.923-9.558 11.239-9.558c-.857-15.289 27.055-23.009 36.625-6.435"
          data-name="Path 17167"
        ></path>
        <path
          d="M103.999 755.759c0-33.76 28.438-23.413 28.438-23.413s-4.438-24.056 25.895-24.056c-1.741-33.924 48.082-53.033 75.139-28.328"
          data-name="Path 17169"
        ></path>
        <path
          d="M325.861 732.486c0-16.85-17.562-11.686-17.562-11.686s2.741-12.006-15.992-12.006c1.219-19.2-38.5-28.889-52.111-8.079"
          data-name="Path 17168"
        ></path>
      </g>
    </svg>
  )
}

export default CloudIcon
